import React, { useState } from 'react'
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    TextField,
    Typography,
    useTheme,
} from '@material-ui/core'

interface AcceptDialogProps {
    open: boolean
    onClose: () => void
    onAccept: (notes: string) => void
    selectedCount: number
}

export const AcceptDialog: React.FC<AcceptDialogProps> = ({
    open,
    onClose,
    onAccept,
    selectedCount,
}) => {
    const theme = useTheme()
    const [notes, setNotes] = useState('')

    const handleSubmit = () => {
        onAccept(notes)
        // Reset the notes field after submission
        setNotes('')
    }

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
            <DialogTitle>Accept Selected Items</DialogTitle>
            <DialogContent>
                <Typography variant="body1" gutterBottom>
                    You are about to accept {selectedCount} selected item
                    {selectedCount !== 1 ? 's' : ''}. Please provide any notes
                    or comments regarding this action.
                </Typography>
                <TextField
                    autoFocus
                    margin="dense"
                    id="notes"
                    label="Notes"
                    placeholder="e.g., Accepted after verification with tenant"
                    multiline
                    rows={4}
                    fullWidth
                    variant="outlined"
                    value={notes}
                    onChange={(e) => setNotes(e.target.value)}
                />
            </DialogContent>
            <DialogActions style={{ padding: theme.spacing(2) }}>
                <Button color="secondary" variant="outlined" onClick={onClose}>
                    Cancel
                </Button>
                <div style={{ flex: 1 }} />
                <Button
                    color="primary"
                    variant="contained"
                    onClick={handleSubmit}
                    disabled={notes.trim().length === 0}
                >
                    Accept
                </Button>
            </DialogActions>
        </Dialog>
    )
}
